import InitialLoader from '@/auth/initialLoader'
import { createFileRoute } from '@tanstack/react-router'


export const Route = createFileRoute('/')({
  component: InitialLoader
})